import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = {
    resources: [
      { label: t('nav.spreadsheet'), href: '/pt/articles/cssbuy-spreadsheet-guide' },
      { label: t('nav.review'), href: '/pt/articles/cssbuy-legit-safety' },
      { label: t('nav.shipping'), href: '/pt/articles/cssbuy-shipping-cost' },
      { label: t('nav.coupon'), href: '/pt/articles/cssbuy-coupon-guide' },
      { label: t('nav.warehouse'), href: '/pt/articles/cssbuy-warehouse-guide' },
      { label: t('nav.legit'), href: '/pt/articles/cssbuy-legit-safety' },
      { label: t('nav.articles'), href: '/pt/articles' },
    ],
    legal: [
      { label: t('footer.about'), href: '/about' },
      { label: t('footer.editorial'), href: '/editorial-policy' },
      { label: t('footer.privacy'), href: '/privacy-policy' },
      { label: t('footer.terms'), href: '/terms' },
    ],
  };

  return (
    <footer className="bg-warm-100 border-t border-warm-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <a href="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-warm-900">
                CSS<span className="text-brand-600">Spreadsheet</span>BR
              </span>
            </a>
            <p className="text-sm text-warm-500 leading-relaxed max-w-xs">
              {t('footer.tagline')}
            </p>
            <div className="mt-4 flex gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-full bg-white border border-warm-200 flex items-center justify-center text-warm-500 hover:text-brand-600 hover:border-brand-300 transition-colors">
                <i className="ri-external-link-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-warm-900 uppercase tracking-wide mb-4">
              {t('footer.links')}
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.resources.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-warm-600 hover:text-brand-600 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-warm-900 uppercase tracking-wide mb-4">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-warm-600 hover:text-brand-600 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-warm-200">
          <p className="text-xs text-warm-400 text-center">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}